import { Recipes as Page } from './recipes';

export const Recipes = () => <Page />;
